import React from "react";
import {clientStore} from "../../lib/clientStorage";
import {getManualFootageOwner} from "../../services/manualFootageService";
import SocialsErrorBoundary from "./SocialsErrorBoundary";
import ContentPage from "../content/ContentPage";
import SocialsConnectedPage from "./SocialsConnectedPage";
export default function SocialsRoute({enabled,onTurnIntoLead,userId}: {enabled: boolean; userId?:string; onTurnIntoLead?: (source: string) => void}) {
  const [revision,setRevision]=React.useState(0);
  React.useLayoutEffect(()=>clientStore.subscribe(key=>{if(key.startsWith("ln:persistence:"))setRevision(v=>v+1);}),[]);
  const owner=React.useMemo(()=>getManualFootageOwner(userId),[userId,revision]);
  const legacy = new URLSearchParams(window.location.search).get("view") === "legacy";
  return enabled && !legacy ? <SocialsErrorBoundary><SocialsConnectedPage key={JSON.stringify([userId,owner])} userId={userId} onTurnIntoLead={onTurnIntoLead} /></SocialsErrorBoundary> : <ContentPage userId={userId} />;
}
